export const REGISTER_FIELD_CHANGE = 'RPS_INFO/REGISTER_FIELD_CHANGE';
export const SET_RPS_INFO = 'RPS_INFO/SET_RPS_INFO';
export const SET_RPS_ERRORS = 'RPS_INFO/SET_RPS_ERRORS';
export const CLEAR_RPS_ERRORS = 'RPS_INFO/CLEAR_RPS_ERRORS';
export const SET_SERVICES = 'RPS_INFO/SET_SERVICES';
export const SET_ECONOMIC_ACTIVIES = 'RPS_INFO/SET_ECONOMIC_ACTIVIES';
export const SET_CERTIFICATE_FILE = 'RPS_INFO/SET_CERTIFICATE_FILE';
export const SET_LOGO_FILE = 'RPS_INFO/SET_LOGO_FILE';
export const CLEAR_RPS_INFO = 'RPS_INFO/CLEAR_RPS_INFO';
export const CLEAR_CERTIFICATE = 'RPS_INFO/CLEAR_CERTIFICATE';
export const HANDLE_LOADING = 'RPS_INFO/HANDLE_LOADING';
export const HANDLE_CERTIFICATE_LOADING = 'RPS_INFO/HANDLE_CERTIFICATE_LOADING';
export const HANDLE_RESTRICTIONS_LOADING = 'RPS_INFO/HANDLE_RESTRICTIONS_LOADING';
export const HANDLE_UNIQUE_SERIES_LOADING = 'RPS_INFO/HANDLE_UNIQUE_SERIES_LOADING';
export const SET_DATA_PAGE = 'RPS_INFO/DATA_PAGE';
export const SET_CITY_CODE = 'RPS_INFO/SET_CITY_CODE';
export const SET_IS_CITY_LOADED = 'RPS_INFO/SET_IS_CITY_LOADED';
export const SET_CONFIG_TYPE = 'RPS_INFO/SET_CONFIG_TYPE';
export const SET_ESTABLISHMENTS_WITH_CONFIG = 'RPS_INFO/SET_ESTABLISHMENTS_WITH_CONFIG';
export const SET_SELECTED_ESTABLISHMENTS_WITH_CONFIG = 'RPS_INFO/SET_SELECTED_ESTABLISHMENTS_WITH_CONFIG';
export const SET_LAST_RPS_SUCCESS = 'RPS_INFO/SET_LAST_RPS_SUCCESS';
export const IS_RPS_CONFIG = 'RPS_INFO/IS_RPS_CONFIG';
export const SET_IS_SEND_NFSE_LOADING = 'RPS_INFO/SET_IS_SEND_NFSE_LOADING';
export const SET_BASIC_INFO = 'RPS_INFO/SET_BASIC_INFO';
export const SET_TABLES = 'RPS_INFO/SET_TABLES';
export const SET_AUTHENTICATION = 'RPS_INFO/SET_AUTHENTICATION';
export const SET_CERTIFICATE = 'RPS_INFO/SET_CERTIFICATE';
export const SET_LOGIN = 'RPS_INFO/SET_LOGIN';
export const SET_TOKEN = 'RPS_INFO/SET_TOKEN';
export const SET_RPS_CONFIG = 'RPS_INFO/SET_RPS_CONFIG';
export const SET_RPS_FILTER = 'RPS_INFO/SET_RPS_FILTER';
export const SET_TERMS_OF_USE_USERS = 'RPS_INFO/SET_TERMS_OF_USE_USERS';
export const SET_TERMS_OF_USE_ACCEPTANCE_DATE_TIME = 'RPS_INFO/SET_TERMS_OF_USE_ACCEPTANCE_DATE_TIME';
export const SET_IS_TERMS_OF_USE_LOADING = 'RPS_INFO/SET_IS_TERMS_OF_USE_LOADING';
